// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1jeE0ZPBBbNIoELEPO5Wxt","projectPropertiesWrapper":"cOrn91zP_cE6OnC9eCQoI","title":"_2soCb9stTNgxUOHFWUzren","showAll":"_3OMzAhRacVdA0VUngZPdpi"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProjectPropertiesContainer/ProjectPropertiesContainer.scss
// module id = 1827
// module chunks = 0